
////////////// DEPENDENCIES AND MODULES /////////////////////////////
/////////////////////////////////////////////////////////////////////

import React, {Component} from 'react';

import './ProvidersPage.css';




////////////// COMPONENT ////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

class ProvidersPage extends Component {



////////////// RENDER LOGIC /////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

  render() {

////////////// RENDER RETURN ////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

      return (
        <div className="ProvidersPageDiv">
          <p>Hello Providers</p>
        </div>
      )

  }

}





////////////// EXPORT MODULE ////////////////////////////////////////
/////////////////////////////////////////////////////////////////////

export default ProvidersPage;




/////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/components/ProvidersPage/ProvidersPage.js